<template>
    <ComLoading v-show="loading" />
    <el-empty  v-show="!vastuuyksikkoSelected" description="Valitse vähintään yksi vastuuyksikkö!" />
    <div v-show="!loading && vastuuyksikkoSelected">
        <el-row>
            <el-col :span="24">
                <ComPagination
                    :total="total"
                    :page-size="paramsObject.paging?.pageSize"
                    v-model:current-page="currentPage"
                    style="float: right" />
            </el-col>
        </el-row>
        <el-table :data="historia" :loading="loading">
            <el-table-column prop="aika" label="Muutosaika">
                <template #default="scope">
                    <el-link type="primary" @click="id = scope.row.huonekortti.id">{{ scope.row.aika.substring(9) }}</el-link>
                </template>
            </el-table-column>
            <el-table-column label="Tekijä">
                <template #default="scope">
                    <el-link type="primary" @click="id = scope.row.huonekortti.id">{{ scope.row.kayttaja.etunimi + ' ' + scope.row.kayttaja.sukunimi }}</el-link>
                </template>
            </el-table-column>
            <el-table-column prop="huonekortti.tilanimike.nimi" label="Tilanimike">
                <template #default="scope">
                    <router-link
                        :to="{ name: 'Huonekortti', params: { huonekorttiId: scope.row.huonekortti.id } }"
                        v-slot="{ href, navigate }"
                        custom>
                        <el-link type="primary" :href="href" @click="navigate">{{ scope.row.huonekortti.tilanimike.nimi }}</el-link>
                    </router-link>
                </template>
            </el-table-column>
            <el-table-column prop="huonekortti.toiminta" label="Täsmennys" show-overflow-tooltip></el-table-column>
            <el-table-column prop="huonekortti.tilat" label="Tilat" show-overflow-tooltip>
                <template #default="scope">
                    {{ formatTilat(scope.row.huonekortti.tilat) }}
                </template>
            </el-table-column>
        </el-table>
    </div>
    <el-drawer v-model="showDrawer" title="Muutos" :size="'50%'" @closed="id = undefined">
        <ComHistoria v-if="id" :id="id" />
    </el-drawer>
</template>
<script lang="ts" setup>
import { hankePage } from '@/views/hanke';
import { computed, ref, watchEffect } from 'vue';
import { useHuonekorttiTable } from '../huonekortit/table/huonekorttiTable';
import ComHistoria from '@/components/huonekortti/historia/ComHistoria.vue';
import { useHuonekortitViimmeisimmatMuutokset } from '@/methods/huonekorttiHistoriaComposables';
import ComLoading from '@/components/common/ComLoading.vue';
import ComPagination from '@/components/common/ComPagination.vue';
import { useKayttaja } from '@/methods/kayttajaComposables';

const { selectedVastuuyksikkoIds } = hankePage()
const { historia, loading, paramsObject, total } = useHuonekortitViimmeisimmatMuutokset()
const { formatTilat } = useHuonekorttiTable()
const { perPage } = useKayttaja()
const id = ref<number>()
const showDrawer = computed(() => !!id.value)
const vastuuyksikkoSelected = computed(() => selectedVastuuyksikkoIds.value && selectedVastuuyksikkoIds.value.length > 0)

const currentPage = computed({
    get: () => paramsObject.value.paging?.currentPage ?? 1,
    set: (value: number) => {
        if (paramsObject.value.paging) {
            paramsObject.value.paging.currentPage = value
        }
    }
})


watchEffect(() => {
    paramsObject.value.vastuuyksikot = selectedVastuuyksikkoIds.value
})

watchEffect(() => {
    if (paramsObject.value.paging && perPage.value) {
        paramsObject.value.paging.pageSize = perPage.value
    }
})

</script>